import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-we-offer',
  templateUrl: './we-offer.component.html',
  styleUrls: ['./we-offer.component.scss']
})
export class WeOfferComponent implements OnInit {

  constructor() { }
  services = [
    {
      imageUrl: '../../../../assets/images/screen.svg',
      title: ' Design',
      desc: 'We create delightful design and branding – intuitive, simple and unique. We will mold your ideal into design aimed to inspire and grow your business.',
    },
    {
      imageUrl: '../../../../assets/images/upload.svg',
      title: 'App Development',
      desc: 'Going mobile we will help your business to establish an application and bring value to the demanding modern customers. With our new approach in mobile app development we will help our clients succeed with a mobile strategy.',
    },
    {
      imageUrl: '../../../../assets/images/touch.svg',
      title: 'Web Development',
      desc: 'We know different ways of how to make your project perform in today’s competitive marketplace. Our team pursue the highest quality of back-end as well as front-end experience.',
    },
    {
      imageUrl: '../../../../assets/images/screen.svg',
      title: 'DevOps',
      desc: 'Our DevOps team works closely with the development team to automate end to end delivery pipeline.',
    },
  ]

  ngOnInit(): void {
  }

}
